
  import {
    CompanyModel,
    ContactAvailableData,
    StockAlias
  } from '@/services/api/models'
  import { computed, defineComponent, onMounted, ref, toRefs, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import Multiselect from '@/components/Select/multiselect.vue'
  import { Field } from 'vee-validate'
  import { MAINACTIONS } from '@/types'

  export default defineComponent({
    name: 'DropdownActions',
    components: { Multiselect, Field },
    props: {
      disabled: Boolean,
      data: {
        type: Object,
        default: () => ({
          name: '',
          type: '',
          fieldId: ''
        })
      },
      lineData: {
        default: () => ({}),
        type: Object
      },
      filterResults: { type: Boolean, default: true },
      classItem: {
        type: String,
        default: 'w-full'
      },
      hasLabel: {
        default: true,
        type: Boolean
      },
      value: {
        default: '',
        type: [String, Array]
      },
      mode: {
        default: 'single',
        type: String
      },
      openDirection: {
        type: String,
        default: 'top'
      },
      callback: {
        type: Function,
        default: () => ({})
      },
      canAddNew: { type: Boolean, default: true },
      validationState: { type: String, default: '' },
      categoryId: { type: String, default: null },
      dataFromExtra: { type: Boolean, default: false },
      stockData: {
        type: Object,
        default: () => ({
          value: [],
          index: -1
        })
      },
      tableId: {
        type: String,
        default: null
      },
      index: {
        type: Number,
        default: -1
      }
    },
    emits: ['onUpdated'],
    setup(props, { emit }) {
      const store = useStore()

      const { t } = useI18n()
      const { data } = toRefs(props)
      const searchText = ref('')
      const fieldName =
        props.tableId && props.index !== -1
          ? `${props.tableId}[${props.index}].${data.value.name}`
          : data.value.name
      const paramsId = computed(() =>
        props.stockData.index === props.index
          ? props.stockData.value
          : props.lineData.contactId
      )
      const addActionSlot = computed(() =>
        props.mode === 'top' ? 'afterlist' : 'beforelist'
      )

      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )

      const extraContactData = computed<ContactAvailableData>(
        () => store.getters[`organizations/contactExtraData`]
      )

      const stocks = computed<StockAlias[]>(() =>
        props.dataFromExtra
          ? extraContactData.value[paramsId.value]?.stocks || []
          : props.categoryId
          ? store.getters[`organizations/stockAliases`].filter(
              (x: StockAlias) => x.stockCategory?.id === props.categoryId
            )
          : store.getters[`organizations/stockAliases`]
      )

      const option = ref<any>(props.value)

      const openModal = () => {
        store.dispatch('ui/toggleModal', {
          display: true,
          contentType: MAINACTIONS.STOCK
        })
      }

      const updateValue = (selected: string) => {
        option.value = selected
        emit('onUpdated', {
          ...data.value,
          value: selected
        })
      }

      const handleSearch = (search: string) => {
        getStocks(search)
      }
      const getStocks = (search?: string) => {
        const filter: any = {}
        if (search) filter.alias = search
        store.dispatch('organizations/GET_STOCK_ALIAS', {
          companyId: currentCompany.value?.id,
          filter
        })
      }

      onMounted(() => {
        console.log(props, 'props. in d-actions forms')

        getStocks()
      })

      watch(props, (prop) => {
        console.log(props, 'props. in d-actions forms')

        option.value = prop.value
      })

      return {
        option,
        fieldName,
        addActionSlot,
        searchText,
        stocks,
        handleSearch,
        updateValue,
        openModal
      }
    }
  })
